import {
  CREATE_PENDING_UNIT_COMMAND,
  DELETE_PENDING_UNIT_COMMAND,
  EDIT_PENDING_UNIT_COMMAND,
  MARK_PENDING_COMMANDS_AS_COMPLETED,
  RECEIVE_AND_WIPE_PENDING_UNIT_COMMANDS,
  RECEIVE_PENDING_UNIT_COMMANDS,
  REQUEST_PENDING_UNIT_COMMAND,
  REQUEST_PENDING_UNIT_COMMANDS_FOR_SITE,
} from '@sophocles/entities/PendingUnitCommand/pendingUnitCommandActions';
import { Map, Set } from 'immutable';

function getState(state, action) {
  let pendingUnitCommands;
  let completed = null;

  switch (action.type) {
    case RECEIVE_PENDING_UNIT_COMMANDS: // Read
      completed = state.get('completed', Set());
      pendingUnitCommands = action.pendingUnitCommands.filter((value, key) => !completed.includes(key));
      return state.set('entities', state.get('entities', Map()).merge(pendingUnitCommands));
    case RECEIVE_AND_WIPE_PENDING_UNIT_COMMANDS:
      completed = state.get('completed', Set());
      pendingUnitCommands = action.pendingUnitCommands.filter((value, key) => !completed.includes(key));
      return state.set('entities', state.get('entities', Map()).clear().merge(pendingUnitCommands));
    case DELETE_PENDING_UNIT_COMMAND: // Delete
      return state.deleteIn(['entities', action.pendingUnitCommand.toString()]);
    case MARK_PENDING_COMMANDS_AS_COMPLETED:
      completed = state.get('completed', Set()).union(action.commands);
      const entities = state.get('entities', Map()).filter((command, key) => !completed.includes(key));
      return state.merge({ entities, completed }); // add in the passed commands to the completed section
    // also, check if any completed are alive in pending, and remove them if so.
    case EDIT_PENDING_UNIT_COMMAND: // Update
    case CREATE_PENDING_UNIT_COMMAND: // Create
    case REQUEST_PENDING_UNIT_COMMAND:
    case REQUEST_PENDING_UNIT_COMMANDS_FOR_SITE:
    default:
      return state;
  }
}

export function pendingUnitCommandReducer(state = Map({ entities: Map(), completed: Set() }), action) {
  switch (action.type) {
    case CREATE_PENDING_UNIT_COMMAND:
    case DELETE_PENDING_UNIT_COMMAND:
    case RECEIVE_PENDING_UNIT_COMMANDS:
    case EDIT_PENDING_UNIT_COMMAND:
    case REQUEST_PENDING_UNIT_COMMAND:
    case REQUEST_PENDING_UNIT_COMMANDS_FOR_SITE:
    case RECEIVE_AND_WIPE_PENDING_UNIT_COMMANDS:
    case MARK_PENDING_COMMANDS_AS_COMPLETED:
      return getState(state, action);
    default:
      return state;
  }
}
